export default __webpack_public_path__ + "static/media/misc-books2-1024w.f8167292.webp";